function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withModifiers } from '../../decorators';
import Box from '../box';
import Button from '../button';
import Text from '../text';

var Modal = function Modal(_ref) {
  var children = _ref.children,
      className = _ref.className,
      cta = _ref.cta,
      displayClose = _ref.displayClose,
      forceControl = _ref.forceControl,
      isActive = _ref.isActive,
      onClose = _ref.onClose,
      others = _objectWithoutProperties(_ref, ["children", "className", "cta", "displayClose", "forceControl", "isActive", "onClose"]);

  var _useState = useState(isActive),
      _useState2 = _slicedToArray(_useState, 2),
      _isActive = _useState2[0],
      setActive = _useState2[1];

  var classes = classNames('modal', {
    'is-active': forceControl ? isActive : _isActive
  }, className);

  var _onClose = function _onClose(e) {
    if (!forceControl) {
      setActive(false);
    }

    onClose && onClose(e);
  };

  var renderCta = function renderCta() {
    if (!cta) return null;

    if (cta && typeof cta.valueOf() === 'string') {
      return React.createElement(Button, {
        "is-primary": true,
        onClick: function onClick() {
          return setActive(true);
        }
      }, React.createElement(Modal.Text, {
        content: cta
      }));
    }

    return React.createElement("div", {
      onClick: function onClick() {
        if (!forceControl) {
          setActive(true);
        }
      }
    }, cta);
  };

  return React.createElement(React.Fragment, null, renderCta(), ReactDOM.createPortal(React.createElement("div", _extends({
    className: classes
  }, others), React.createElement("div", {
    className: "modal-background",
    onClick: function onClick(e) {
      return _onClose(e);
    }
  }), React.createElement("div", {
    className: "modal-content"
  }, React.createElement(Box, null, React.createElement(Box.Content, {
    "is-rounded": true
  }, children)), displayClose && React.createElement("button", {
    className: "modal-close is-large",
    onClick: function onClick(e) {
      return _onClose(e);
    },
    "aria-label": "close"
  }))), document.body));
};

Modal.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  cta: PropTypes.any,
  forceControl: PropTypes.bool,
  isActive: PropTypes.bool,
  onClose: PropTypes.func,
  displayClose: PropTypes.bool
};
Modal.Text = Text;
Modal.defaultProps = {
  displayClose: true
};
export default withModifiers(Modal);